import styled from "styled-components";
import theme from "../../../styles/theme";

export const H1 = styled.h1`
  font-family: ${theme.h1FontFamily};
  font-size: ${theme.h1FontSize};
  font-weight: ${theme.h1FontWeight};
`;

export const H2 = styled.h2`
  font-family: ${theme.h1FontFamily};
  font-size: ${theme.h2FontSize};
  font-weight: ${theme.h1FontWeight};
`;

export const H3 = styled.h3`
  font-family: ${theme.h1FontFamily};
  font-size: ${theme.h3FontSize};
  font-weight: ${theme.h1FontWeight};
`;

export const H4 = styled.h4`
  font-family: ${theme.h1FontFamily};
  font-size: ${theme.h4FontSize};
  font-weight: ${theme.h1FontWeight};
`;

export const H5 = styled.h5`
  font-family: ${theme.h1FontFamily};
  font-size: ${theme.h5FontSize};
  font-weight: ${theme.h1FontWeight};
`;

export const H6 = styled.h6`
  font-family: ${theme.h1FontFamily};
  font-size: ${theme.h6FontSize};
  font-weight: ${theme.h1FontWeight};
`;

/*
 * Common headers for redesign
 */

export const Header = styled.h1`
  font-family: ${theme.primaryFontFamily};
  font-size: ${theme.headerFontSize};
`;
